import { render, staticRenderFns } from "./CheckSubjectChoice.vue?vue&type=template&id=404bc0fe&scoped=true&"
import script from "./CheckSubjectChoice.vue?vue&type=script&lang=js&"
export * from "./CheckSubjectChoice.vue?vue&type=script&lang=js&"
import style0 from "./CheckSubjectChoice.vue?vue&type=style&index=0&id=404bc0fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404bc0fe",
  null
  
)

export default component.exports